/**
 * One correlation ID per browser tab (sessionStorage) so API calls in the same
 * session share a trace; backend echoes X-Correlation-ID for log correlation.
 */

const STORAGE_KEY = "csp_x_correlation_id";

export const CORRELATION_HEADER = "X-Correlation-ID";

function newCorrelationId(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
}

export function getOrCreateCorrelationId(): string {
  if (typeof window === "undefined") {
    return newCorrelationId();
  }
  let id = sessionStorage.getItem(STORAGE_KEY);
  if (!id) {
    id = newCorrelationId();
    sessionStorage.setItem(STORAGE_KEY, id);
  }
  return id;
}

export function correlationHeaders(): Record<string, string> {
  return { [CORRELATION_HEADER]: getOrCreateCorrelationId() };
}

export function syncCorrelationIdFromHeaders(headers: Headers): void {
  if (typeof window === "undefined") return;
  const raw =
    headers.get("x-correlation-id") ?? headers.get(CORRELATION_HEADER);
  if (raw?.trim()) {
    sessionStorage.setItem(STORAGE_KEY, raw.trim());
  }
}

/** Axios response / error response headers (AxiosHeaders or plain object). */
export function syncCorrelationIdFromAxiosHeaders(headers: unknown): void {
  if (typeof window === "undefined" || headers == null || typeof headers !== "object") {
    return;
  }
  let raw: string | undefined;
  const h = headers as { get?: (name: string, ...args: unknown[]) => unknown };
  if (typeof h.get === "function") {
    const a = h.get("x-correlation-id");
    const b = h.get("X-Correlation-ID");
    raw = [a, b].find((v): v is string => typeof v === "string");
  }
  if (raw == null) {
    const o = headers as Record<string, string>;
    raw = o["x-correlation-id"] ?? o["X-Correlation-ID"];
  }
  if (raw?.trim()) {
    sessionStorage.setItem(STORAGE_KEY, raw.trim());
  }
}
